module.exports = __webpack_public_path__ + "img/dolly-empty.4a1f99f9.svg";